/** @format */

import React from "react";
import "./loading.css";
export default function LoadingText() {
  return (
    <div>
      <div className=" m-auto text-loading">
        <div className="card__image dark:bg-gray-800  bg-gray-400 loading"></div>
      </div>
    </div>
  );
}
